import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./i18n";
import vueaxios from "vue-axios";
import axios from "axios";
import '@/assets/icons';
import SvgIcon from '@/views/svgIcon.vue'
import { jsFn } from '@/utils/jsFn'
import {
  // create naive ui
  create,
  // component
  NButton,
  NSpin,
  NDialogProvider,
  NIcon,
  NIconWrapper,
  NInput,
  NModal,
  NCard,
  NForm,
  NFormItem,
  NTabs,
  NTabPane,
  NDrawer,
  NDrawerContent,
  NSelect,
  NInputGroup,
  NInputGroupLabel,
  NAlert,
  NQrCode
} from 'naive-ui'

const naive = create({
  components: [
    NSpin, NDialogProvider, NButton, NIcon, NIconWrapper, NInput,
    NModal, NCard, NForm, NFormItem, NTabs, NTabPane, NDrawer,
    NDrawerContent, NSelect, NInputGroup, NInputGroupLabel,
    NAlert, NQrCode
  ]
})

router.beforeEach((to, from, next) => {
  // console.log(to, 'to')
  // console.log(from, 'from')
  if(to.meta.title) {
    document.title = to.meta.title;
  } else {
    document.title = 'MyNews';
  }

  let reg = /\/(tw|kr|jp|en)/
  if(jsFn.isCN() && reg.test(to.fullPath)) {
    let teee = to.fullPath.replace(reg, '/cn')    
    next(teee);
  } else {
    next();
  }
});

// 維持 vuex state 的資訊
store.dispatch('keepState')
store.dispatch('coreApi/keepState')
// store.dispatch('activity/keepState')

createApp(App)
  .use(i18n)
  .use(store)
  .use(router)
  .use(vueaxios, axios)
  .component('svg-icon', SvgIcon)
  .use(naive)
  .mount("#app");
